import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CloseButton, Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import Button from '../../elements/Button';
import LoadingBars from '../../elements/LoadingBars';
import styles from './styles.scoped.css';
import { formatCountdown, maskEmail } from '../../../utils/format';
import { useTimer } from 'react-timer-hook';

function ModalPasswordExpired({
  handleClose,
  open,
  handleSubmit,
  isLoading,
  handleExpired,
}) {
  const { username } = useSelector((s) => s.login);
  const { data, code } = useSelector((s) => s.resetPassword);

  const { minutes, seconds, restart } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => handleExpired(),
    autoStart: false,
  });

  useEffect(() => {
    if (data?.countdown) {
      const time = new Date();
      time.setSeconds(time.getSeconds() + data?.countdown);
      restart(time);
    }
  }, [code, data?.countdown]);

  return (
    <Modal
      centered
      onClose={handleClose}
      opened={open}
      size={'lg'}
      withCloseButton={false}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <h5>Perbarui Kata Sandi</h5>
          <span onClick={handleClose}>
            <CloseButton />
          </span>
        </div>
        {code === 429 ? (
          <p>
            Anda telah melakukan permintaan untuk memperbarui kata sandi.
            Periksa kotak masuk email Anda{' '}
            <strong>{maskEmail(username)}</strong>. Apabila tidak menerima
            email, harap masuk kembali untuk melakukan permintaan pembaruan
            ulang setelah <strong>{formatCountdown(minutes, seconds)}</strong>.
          </p>
        ) : (
          <p>
            Tidak dapat mengakses Dashboard Console karena kata sandi perlu
            diperbarui. Kami akan mengirimkan email berisi petunjuk pembaruan
            kata sandi ke alamat email Anda{' '}
            <strong>{maskEmail(username)}</strong>. Apakah Anda ingin
            memperbarui kata sandi?
          </p>
        )}
        <div className={styles['container-btn']}>
          <Button
            onClick={handleClose}
            style={code === 429 ? 'default' : 'outlined'}
            type="button"
          >
            Tutup
          </Button>
          {code !== 429 && (
            <Button
              className={styles['btn-submit']}
              disabled={isLoading}
              onClick={() => handleSubmit(username)}
              type="button"
            >
              {isLoading && <LoadingBars size={1} />}
              <span> Kirim Email Pembaruan Kata Sandi</span>
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ModalPasswordExpired;

ModalPasswordExpired.propTypes = {
  handleClose: PropTypes.func,
  handleExpired: PropTypes.func,
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  open: PropTypes.bool,
};
